import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const allocationSettingCsvUploadSlice = createSlice({
  name: 'allocationSettingCsvUpload',
  initialState: { allocationSettingCsvUpload: initialState },
  reducers: {
    allocationSettingCsvUploadApi: (state, data) => {
      state.allocationSettingCsvUpload = data.payload;
    },
  },
});

export const { allocationSettingCsvUploadApi } = allocationSettingCsvUploadSlice.actions;

export default allocationSettingCsvUploadSlice.reducer;
